/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { inventoryActionCreators } from "../../services/Actions";
import RenderInventoryPage from "../RenderInventoryPage";
import Loader from "../../Components/Loader";
import TablePagination from "../components/TablePagination";

const PAGE_SIZE = 12;

const TYPE_STYLES = {
  IN: "bg-emerald-100 text-emerald-700",
  OUT: "bg-rose-100 text-rose-700",
  ADJUST: "bg-amber-100 text-amber-700",
  RESERVE: "bg-blue-100 text-blue-700",
  RELEASE: "bg-indigo-100 text-indigo-700",
  STOCK_TAKE: "bg-purple-100 text-purple-700",
};

function Movements() {
  const dispatch = useDispatch();
  const { GetMovements } = bindActionCreators(inventoryActionCreators, dispatch);
  const inventory = useSelector((state) => state.inventory);
  const { movements, isLoading } = inventory;

  const [type, setType] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    GetMovements({ type: type || undefined, limit: 300 });
  }, [type]);

  // Reset to first page when the movement list changes.
  useEffect(() => {
    setPage(1);
  }, [movements]);

  const pagedMovements = (movements || []).slice(
    (page - 1) * PAGE_SIZE,
    page * PAGE_SIZE
  );

  return (
    <RenderInventoryPage title={"Stock Movements"}>
      {isLoading && <Loader />}

      <div className="flex items-center gap-3 mb-5">
        <label className="text-sm font-semibold text-gray-600">Filter:</label>
        <select value={type} onChange={(e) => setType(e.target.value)} className="px-3 py-2 text-sm border border-gray-300 rounded-lg">
          <option value="">All types</option>
          {Object.keys(TYPE_STYLES).map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </div>

      <section className="bg-white dark:bg-gray-800 shadow-sm rounded-xl border border-gray-100 dark:border-gray-700">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 dark:bg-gray-900/40">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase">When</th>
                <th className="px-4 py-3 text-left text-xs font-bold text-gray-500 uppercase">Item</th>
                <th className="px-4 py-3 text-center text-xs font-bold text-gray-500 uppercase">Type</th>
                <th className="px-4 py-3 text-center text-xs font-bold text-gray-500 uppercase">Change</th>
                <th className="px-4 py-3 text-center text-xs font-bold text-gray-500 uppercase">Balance</th>
                <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase">Reason</th>
                <th className="px-4 py-3 text-left text-xs font-bold text-gray-500 uppercase">By</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {(movements || []).length === 0 ? (
                <tr><td colSpan={7} className="px-6 py-10 text-center text-sm text-gray-400">No movements recorded yet.</td></tr>
              ) : (
                pagedMovements.map((m) => (
                  <tr key={m._id} className="hover:bg-gray-50 dark:hover:bg-gray-700/40">
                    <td className="px-6 py-3 text-sm text-gray-500 whitespace-nowrap">{new Date(m.created_at).toLocaleString()}</td>
                    <td className="px-4 py-3 text-sm font-mono">{m?.item?.sku || "—"}</td>
                    <td className="px-4 py-3 text-center">
                      <span className={`px-2.5 py-1 text-xs font-bold rounded-full ${TYPE_STYLES[m.type] || "bg-gray-100 text-gray-600"}`}>{m.type}</span>
                    </td>
                    <td className={`px-4 py-3 text-center text-sm font-bold ${m.qty_delta > 0 ? "text-emerald-600" : "text-rose-600"}`}>
                      {m.qty_delta > 0 ? `+${m.qty_delta}` : m.qty_delta}
                    </td>
                    <td className="px-4 py-3 text-center text-sm">{m.balance_after ?? "—"}</td>
                    <td className="px-6 py-3 text-sm text-gray-600 max-w-xs truncate">{m.reason || "—"}</td>
                    <td className="px-4 py-3 text-sm text-gray-500">{m?.performed_by?.name || "System"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <TablePagination
          page={page}
          pageSize={PAGE_SIZE}
          total={(movements || []).length}
          onPageChange={setPage}
        />
      </section>
    </RenderInventoryPage>
  );
}

export default Movements;
